import {combineReducers} from '@modifi/redux'

import beneficialOwnerReducer, {BeneficialOwnerState} from './beneficial-owners/reducer'
import companyReducer, {CompanyState} from './company/reducer'
import companyDocumentsReducer, {CompanyDocumentsState} from './company-documents/reducer'
import companyRegistrationReducer, {CompanyRegistrationState} from './company-registration/reducer'
import directDebitBankAccountReducer, {
  DirectDebitBankAccountState,
} from './direct-debit-account/reducer'
import financingOptionsReducer, {FinancingOptionsState} from './financing-options/reducer'
import legalRepresentativeReducer, {
  LegalRepresentativesState,
} from './legal-representatives/reducer'
import directorReducer, {DirectorsState} from './directors/reducer'
import personDocumentsReducer, {PersonDocumentsState} from './person-documents/reducer'
import publicRegisteredCompaniesReducer, {
  PublicRegisteredCompaniesState,
} from './public-registered-companies/reducer'
import sellerBankAccountsReducer, {SellerBankAccountsState} from './seller-bank-accounts/reducer'
import inputFieldsReducer, {InputFieldsState} from './input-fields/reducer'
import sellerTradePartnersReducer, {SellerTradePartnerState} from './seller-trade-partners/reducer'
import userReducer, {UserState} from './user/reducer'
import currencyReducer, {CurrencyState} from './currencies/reducer'
import bankUtilsReducer, {BankUtilsState} from './bank-utils/reducer'
import intermediaryShareholderReducer, {
  IntermediaryShareholdersState,
} from './intermediary-shareholders/reducer'
import buildVersionMatchReducer, {BuildVersionMatchState} from './build-version-match/reducer'
import legalFormReducer, {LegalFormsState} from './legal-forms/reducer'
import industryReducer, {IndustryState} from './industries/reducer'
import revenueCategoryReducer, {RevenueCategoryState} from './revenue-categories/reducer'
import financialDataSetReducer, {FinancialDataSetState} from './financial-data-set/reducer'
import tasksReducer, {TasksState} from './tasks/reducer'
import statesReducer, {AddressStateState} from './states/reducer'
import registrationTypesReducer, {RegistrationTypesState} from './registration-types/reducer'
import exchangeRateReducer from './exchange-rate/reducer'

// @ts-expect-error to be fixed
export default combineReducers<DataState>({
  beneficialOwners: beneficialOwnerReducer,
  company: companyReducer,
  companyDocuments: companyDocumentsReducer,
  companyRegistration: companyRegistrationReducer,
  directDebitBankAccount: directDebitBankAccountReducer,
  financingOptions: financingOptionsReducer,
  inputFields: inputFieldsReducer,
  legalRepresentatives: legalRepresentativeReducer,
  directors: directorReducer,
  personDocuments: personDocumentsReducer,
  publicRegisteredCompanies: publicRegisteredCompaniesReducer,
  sellerBankAccounts: sellerBankAccountsReducer,
  sellerTradePartners: sellerTradePartnersReducer,
  user: userReducer,
  currencies: currencyReducer,
  bankUtils: bankUtilsReducer,
  intermediaryShareHolders: intermediaryShareholderReducer,
  buildVersionMatch: buildVersionMatchReducer,
  legalForms: legalFormReducer,
  industries: industryReducer,
  revenueCategories: revenueCategoryReducer,
  financialDataSet: financialDataSetReducer,
  tasks: tasksReducer,
  addressStates: statesReducer,
  registrationTypes: registrationTypesReducer,
  exchangeRate: exchangeRateReducer,
})

export type DataState = {
  beneficialOwners: BeneficialOwnerState
  company: CompanyState
  companyDocuments: CompanyDocumentsState
  companyRegistration: CompanyRegistrationState
  directDebitBankAccount: DirectDebitBankAccountState
  financingOptions: FinancingOptionsState
  inputFields: InputFieldsState
  legalRepresentatives: LegalRepresentativesState
  directors: DirectorsState
  personDocuments: PersonDocumentsState
  publicRegisteredCompanies: PublicRegisteredCompaniesState
  sellerBankAccounts: SellerBankAccountsState
  sellerTradePartners: SellerTradePartnerState
  user: UserState
  currencies: CurrencyState
  bankUtils: BankUtilsState
  intermediaryShareHolders: IntermediaryShareholdersState
  buildVersionMatch: BuildVersionMatchState
  legalForms: LegalFormsState
  industries: IndustryState
  revenueCategories: RevenueCategoryState
  financialDataSet: FinancialDataSetState
  tasks: TasksState
  addressStates: AddressStateState
  registrationTypes: RegistrationTypesState
}
